import * as React from 'react';
import Page from '../Page';
import AfrSummaryCore from '../AfrCore/AfrSummaryCore';
import { UserRoleEnum } from '../../redux/UserSlice';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';
import { useAppSelector, useAppDispatch } from '../../hooks/index';




const AfrSummary = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);
   
    return (
        <React.Fragment>
            <Page>
                <AfrSummaryCore userRole={isAdminUser ? UserRoleEnum.Admin : UserRoleEnum.EntityUser } dataSection="Summary" />
            </Page>
        </React.Fragment>
        );
}

export default AfrSummary;